<template>
  <div class="banner-block md:mb-48 overflow-hidden bg-grey-lighter sm:bg-transparent px-16 sm:px-0">
    <template v-if="meta.path">
      <div :class="meta.path && 'cursor-pointer'" @click="clickBanner(meta)">
        <div class="banner link ease" :style="bannerStyle"></div>
      </div>
    </template>
    <template v-else>
      <div class="banner" :style="bannerStyle"></div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'module_Banner',
  props: ['meta', 'data'],
  data () {
    return {
      coverDesktopSize: {
        width: 0,
        height: 0
      },
      coverMobileSize: {
        width: 0,
        height: 0
      },
      MAGNIFACATION: 1.5
    }
  },
  computed: {
    ...mapGetters(['isDesktop', 'initWidth']),
    bannerImageWidth: function () {
      if (this.initWidth >= 1200) {
        return 1168
      } else if (this.initWidth < 1200 && this.initWidth >= 992) {
        return 960
      } else if (this.initWidth < 992 && this.initWidth >= 801) {
        return 736
      } else if (this.initWidth < 801 && this.initWidth >= 768) {
        return 736
      } else if (this.initWidth < 768 && this.initWidth >= 581) {
        return 576
      } else {
        return 576
      }
    },
    bannerStyle: function () {
      if (this.isDesktop) {
        return this.meta.coverDesktop ? {
          backgroundImage: `url('${this.meta.coverDesktop}?width=${this.bannerImageWidth * this.MAGNIFACATION}&format=webp')`,
          paddingTop: this.coverDesktopSize.height / this.coverDesktopSize.width * 100 + '%'
        } : {}
      } else {
        return this.meta.coverMobile ? {
          backgroundImage: `url('${this.meta.coverMobile}?width=${this.bannerImageWidth * this.MAGNIFACATION}&format=webp')`,
          paddingTop: this.coverMobileSize.height / this.coverMobileSize.width * 100 + '%'
        } : {}
      }
    }
  },
  methods: {
    clickBanner (banner) {
      if (banner.path) {
        window.open(banner.path)
      }
      window.dataLayer.push({
        event: 'index_banner',
        key: banner.loc
      })
    }
  },
  mounted () {
    if (this.meta.coverDesktop) {
      let coverDesktop = new Image()
      coverDesktop.src = this.meta.coverDesktop + `?format=webp`
      coverDesktop.onload = () => {
        this.coverDesktopSize.width = coverDesktop.width
        this.coverDesktopSize.height = coverDesktop.height
      }
    }

    if (this.meta.coverMobile) {
      let coverMobile = new Image()
      coverMobile.src = this.meta.coverMobile + `?format=webp`
      coverMobile.onload = () => {
        this.coverMobileSize.width = coverMobile.width
        this.coverMobileSize.height = coverMobile.height
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.banner-block
  @screen md
    border-radius: 1.25rem
.banner
  border-radius: 1.25rem
  background:
    position: center
    repeat: no-repeat
    size: cover
  &.link:hover
    transform: scale(1.05, 1.05)
</style>
